export var TextColor;
(function (TextColor) {
    TextColor["OnSurface"] = "on-surface";
    TextColor["Primary"] = "primary";
    TextColor["Explanatory"] = "explanatory";
    TextColor["OnPopupMenu"] = "on-popup-menu";
})(TextColor || (TextColor = {}));
export var TextState;
(function (TextState) {
    TextState["Default"] = "";
    TextState["Active"] = "active";
    TextState["Disabled"] = "disabled";
})(TextState || (TextState = {}));
